import { useState } from 'react';
import { getQueryStringValue, setQueryStringValue } from 'hooks';

/**
 * @param {Array<Object>} tabsDefinition
 * @param {Object} [props]
 */
export const useTabsHandler = (
  tabsDefinition,
  { enableUrlNavigation = true, useIndexes = false, initialValue = null, paramKey = 'tab' } = {}
) => {
  const paramValue = enableUrlNavigation
    ? getQueryStringValue(paramKey) || initialValue
    : initialValue;
  const initialTab = useIndexes ? Number(paramValue) : paramValue;
  const [selectedTab, setSelectedTab] = useState(initialTab || 0);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    enableUrlNavigation && setQueryStringValue(paramKey, newValue);
  };

  return { handleTabChange, selectedTab };
};
